import { Agent } from "./agent.model";
import { EventType } from "../services";
import { Status } from "./status.model";

export class Meeting{
    Id:number;
    AgentId: number;
    Agent:any;
    EventType:EventType
    LastName: string;
    FirstName: string;
    MiddleName: string;
    Phone: string;
    Email: string;
    Date: Date
    isFirst: boolean
    Result: string;
    Comment: string;
    PolicyNum: string;
    NextDate: Date;
    DocumentStatus: Status;
    PersonId: number;
    DocumentsStatus:any;
    Agent_Name:any;
    Agent_FirstName:any;
    Agent_MiddleName:any;
    DocumentsStatus_Name:any;
}